export default {
  data() {
    return {
      columns: [
        {
          title: 'ITcode',
          dataIndex: 'username',
          disabled: true,
          width: '20%',
        },
        {
          title: '姓名',
          dataIndex: 'name',
          disabled: true,
        },
        {
          title: '业务类型',
          dataIndex: 'business',
          disabled: true,
        },
        {
          title: '业务模式',
          dataIndex: 'model',
          disabled: true,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 220,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
